import wx from 'weixin-js-sdk'
import publicObj from './public'
const buySuc = location.origin + '/order/evaluate';
const rechartSuc = location.origin + '/my/vipRecharge';
// console.log(buySuc)
console.log(wx.chooseWXPay)
export default {
  // 1微信MWEB,2微信JSAPI公号，3微信JSAPI小程序

  payChannel: {
    webAli: 'AliPay_h5',
    webWx : 'WeChat_h5',
    JSApi: 'WeChat',
    JSApiMini : '',
  },
  //支付成功后跳转页面
  // 买家订单列表
  
  // 获取支付参数
  getPayParams(payType) {

    let obj = {
      payChannel: '',
      backUrl: ''
    };

    if (publicObj.isWeiXin()) {
      
      obj.payChannel = this.payChannel.JSApi
      obj.backUrl = buySuc;
    } else {
      if(payType){
        //站外微信支付
        obj = {
          payChannel : this.payChannel.webWx,
          backUrl : buySuc
        }
      }else{
        //站外支付宝支付
        obj = {
          payChannel : this.payChannel.webAli,
          backUrl : buySuc
        }
      }

    }
    return obj
  },
  //确认支付
  confirmPay(payChannel, data,type,back,callback) {
   
    switch (payChannel) {
      case this.payChannel.mWeb:
        location.href = data.h5PayUrl;
        break;
      case this.payChannel.JSApi:
        wx.ready(function () {
          const {timestamp, nonceStr, packageStr, signType, paySign} = data.chooseWXPayParam;
          // alert(JSON.stringify(data.chooseWXPayParam))
          console.log(timestamp)
          let config = {
            timestamp,
            nonceStr,
            package: packageStr,
            signType,
            paySign,
          };
          // alert(JSON.stringify(config))
          
          wx.chooseWXPay({
         
            timestamp : config.timestamp,
            nonceStr : config.nonceStr,
            package : config.package,
            signType : config.signType,
            paySign : config.paySign,
            success: function (res) {
              console.log(res,'--------------')
              // 支付成功后的回调函数
              // alert('支付成功')
              // alert(window.location.href);
              // let href = window.location.href.split('')[0];
              // alert(href)
              if(back){
                window.location.href = back;
                return;
              }
              if(type == 1 || type == 3){
                window.location.href = buySuc + '?type=' + type
              }else{
                window.location.href = rechartSuc;
              }
              
              
            },

            cancel: function(res) {  
              //支付取消  
              if(callback){
                callback();
              }else{
                window.location.reload()
              }
            }, 

            fail: function (res) {
              alert(res.errMsg)
            },
            complete: function () {
              
            }
          });
        });

        break;
    }

  },

}
